import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { Activity } from "lucide-react";
import { fmtK } from "@/lib/traffic";

// "Data is coming in" pulse: rows received from the Edge sender per minute over the last hour. Red stubs mark minutes with nothing received.
export function FeedPulse({ feed }) {
  const pts = feed?.arrivals || [];
  const max = Math.max(1, ...pts.map((p) => p.rows));
  const data = pts.map((p) => ({ ...p, gap: p.rows ? 0 : max * 0.08 }));
  const total = pts.reduce((a, p) => a + p.rows, 0);
  const last = pts[pts.length - 1];
  const quiet = pts.filter((p) => !p.rows).length;
  return (
    <div className="flex min-w-0 flex-1 items-center gap-3 rounded-2xl border border-border/60 bg-secondary/30 px-3 py-1.5" data-testid="feed-pulse">
      <div className="shrink-0 leading-tight">
        <div className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground"><Activity className="h-3 w-3" /> Data arriving</div>
        <div className="num text-base font-semibold" data-testid="feed-pulse-now">{fmtK(last?.rows ?? 0)} <span className="text-[10px] font-normal text-muted-foreground">rows this minute</span></div>
        <div className="num text-[10px] text-muted-foreground" data-testid="feed-pulse-total">{fmtK(total)} rows · last 60 min{quiet ? ` · ${quiet} silent min` : ""}</div>
      </div>
      <div className="h-12 min-w-0 flex-1" data-testid="feed-pulse-chart">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 2, right: 0, bottom: 0, left: 0 }} barCategoryGap={1}>
            <Tooltip cursor={{ fill: "hsl(var(--secondary))" }} content={({ payload }) => payload?.[0] ? <div className="rounded-lg border bg-popover px-2 py-1 text-[11px] shadow">{payload[0].payload.t} · {fmtK(payload[0].payload.rows)} rows{payload[0].payload.export ? ` (${fmtK(payload[0].payload.export)} backlog)` : ""}</div> : null} />
            <Bar dataKey="rows" stackId="a" isAnimationActive={false} radius={[2, 2, 0, 0]}>
              {data.map((p, i) => <Cell key={i} fill={p.export > p.live ? "#f59e0b" : "#10b981"} />)}
            </Bar>
            <Bar dataKey="gap" stackId="a" fill="#f43f5e" isAnimationActive={false} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="hidden shrink-0 text-right text-[10px] leading-tight text-muted-foreground 2xl:block">
        <div>{pts[0]?.t} → {last?.t}</div>
        <div><span className="inline-block h-1.5 w-1.5 rounded-sm bg-emerald-500" /> live · <span className="inline-block h-1.5 w-1.5 rounded-sm bg-amber-500" /> backlog · <span className="inline-block h-1.5 w-1.5 rounded-sm bg-rose-500" /> nothing</div>
      </div>
    </div>
  );
}
